$(document).ready(function () {
  var test = $("#MainContent .shopify-section").first().outerHeight() ;

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= test) {
      $("#Sticky-wrapper").addClass("fixed");
      $("#Sticky-wrapper").removeClass("unfixed");
    } else {
      $("#Sticky-wrapper").addClass("unfixed");
      $("#Sticky-wrapper").removeClass("fixed");
    }
  });
});
